module.exports = __webpack_public_path__ + "img/door_on_sawhorses.b5b145ca.webp";